import { CdkPortalOutlet } from '@angular/cdk/portal';
import { NgModule } from '@angular/core';
import { OutlineButtonComponent } from '../button/button.component';
import { IconComponent } from '../icon/icon.component';
import { MenuItemComponent } from '../menu/components/item/item.component';
import { MenuTriggerDirective } from '../menu/directives/trigger/trigger.directive';
import { MenuComponent } from '../menu/menu.component';
import { TabComponent } from './components/tab/tab.component';
import { TabGroupComponent } from './tab-group.component';
import { MenuTriggerButtonDirective } from '../menu/directives/trigger-button/trigger-button.directive';

@NgModule({
    imports: [
        TabComponent,
        TabGroupComponent,
        IconComponent,
        CdkPortalOutlet,
        MenuTriggerDirective,
        MenuItemComponent,
        MenuComponent,
        OutlineButtonComponent,
        MenuTriggerButtonDirective
    ],
    exports: [TabComponent, TabGroupComponent]
})
export class TabsModule {}
